import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { catchError, of, switchMap } from 'rxjs';
import { EmailHubService } from 'src/app/private/services/email-hub.service';
import { UploadService } from 'src/app/private/services/upload.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { EditorModule } from 'primeng/editor';
import { MessageService } from 'primeng/api';
import Quill from 'quill';
@Component({
  selector: 'app-mail-right-section',
  imports: [SharedModule, EditorModule],
  templateUrl: './mail-right-section.component.html',
  styleUrl: './mail-right-section.component.scss'
})
export class MailRightSectionComponent implements OnInit, OnDestroy {
  @Input() selectedRow!: any;
  @Input() fetchingDraftData = false;
  @Input() sanitizedContent: SafeHtml | null = null;
  @Input() isComposeOpen = false;
  @Output() refresh = new EventEmitter<any>();
  @Input() loadingEmailData = false;
  @Input() activeAction: string = 'inbox';
  @Input() isDraft = false;
  @Input() currentCreatedDraftId: any;

  @Output() closeCompose = new EventEmitter<any>();
  @Output() closeCompose2 = new EventEmitter<any>();
  @Output() makeIsDraftFalse = new EventEmitter<any>();
  @Output() composeNewEmail = new EventEmitter<any>();

  @ViewChild('messageContainer', { static: false }) messageContainer!: ElementRef;
  @ViewChild('attachmentsSection', { static: false }) attachmentsSection!: ElementRef;

  openBCC = false;
  openCC = false;

  // Scroll debounce timer
  private scrollTimeout: any;

  // PrimeNG Editor
  editorData: string = ''; // Editor content

  files: any[] = [];
  to: string = '';
  cc: string = '';
  bcc: string = '';
  subject: string = '';
  btnLoading = false;
  emailInput: string = '';
  emails: string[] = [];
  ccInput: string = '';  // Holds the current input value for CC
  ccEmails: string[] = []; // Array to store CC emails as chips
  draft_message_id: any;
  isReply = false;
  isReplyAll = false;
  isForward = false;
  hoverIndex: any = -1;
  hoverIndex2: any = -1;
  replyId: any;
  attachments: any[] = [];
  ckconfig: any;
  currentSingature: string = '';
  uploadedAttachments: any[] = []; // Array to store uploaded attachments
  updateDraft: any;

  // Add these methods to your component
  showAttachmentDialog = false;
  selectedAttachment: any = null;

  openAttachment(attachment: any) {
    this.selectedAttachment = {
      ...attachment,
      url: this.getImageUrl(attachment.contentType, attachment.contentBytes)
    };
    this.showAttachmentDialog = true;
  }

  formatFileSize(bytes: number): string {
    if (!bytes) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  getInitials(name: string): string {
    return name?.split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase() || 'UN';
  }

  openCompose() {
    this.composeNewEmail.emit();
  }

  downloadAttachment(attachment: any) {
    const link = document.createElement('a');
    link.href = this.getImageUrl(attachment.contentType, attachment.contentBytes);
    link.download = attachment.name;
    link.click();
  }

  constructor(
    // private toast: ToastrService,
    private api: EmailHubService,
    private localStorage: LocalStorageService,
    private sanitizer: DomSanitizer,
    // private modalService: NgbModal,
    private messageService: MessageService,
    private uploadService: UploadService
  ) {

  }

  ngOnInit() {

    // make attachments and text empty
    this.files = [];
    this.uploadedAttachments = [];
    this.editorData = '';

    let signature = this.localStorage.getSignatures();
    signature.forEach((element: any) => {
      if (element.isActive === true || element.isActive === 'true') {
        this.currentSingature = element.signature;
      }
    });

    const Block : any = Quill.import('blots/block');
    Block.tagName = 'div';
    Quill.register(Block, true);

    console.log('Current Signature:', this.currentSingature);
  }

  ngOnDestroy(): void {
    // Clear any pending scroll timeout to prevent memory leaks
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedRow'] && !changes['selectedRow'].firstChange) {
      // Reset flags to false if selectedRow changes

      if (this.isReply || this.isReplyAll || this.isForward) {
        this.handleUpdateDraft();
      }

      this.isReply = false;
      this.isReplyAll = false;
      this.isForward = false;
      this.replyId = null;
      this.clearData();
    }

    console.log("this draft", this.isDraft);

    if (changes['isComposeOpen'] && !changes['isComposeOpen'].firstChange) {
      if (this.isComposeOpen && this.fetchingDraftData === false &&
        this.currentSingature
      ) {
        this.editorData = `<p><br></p><p><br></p><p><br></p><p><br></p>${this.currentSingature}`;

      }
    }
  }


  selectAction(action: string): void {
    // this.bottomSheetRef.dismiss(action);
  }

  openLink(event: MouseEvent): void {
    // this.bottomSheetRef.dismiss();
    event.preventDefault();
  }

  handleOpenBCC() {
    this.openBCC = !this.openBCC;
  }

  handleOpenCC() {
    this.openCC = !this.openCC;
  }

  async onFileSelected(event: any) {
    const selectedFiles: FileList = event.target.files;

    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];

      if (file.size > 4 * 1024 * 1024) {
        this.messageService.add({
          severity: 'error',
          summary: 'File size error',
          detail: 'File size cannot be more than 4MB'
        });
        continue;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const preview = e.target.result;

        const fileObj = {
          file,
          preview,
          uploaded_url: '',
          uploading: true,
          success: false,
          error: false,
        };

        this.files.push(fileObj);
        this.uploadFileParallel(file, this.files.length - 1);

        // Auto-scroll to attachments section after file is added (with delay for better UX)
        // if (this.files.length === 1) { // Only scroll on first file to avoid excessive scrolling
        //   this.scrollToAttachments();
        // }
      };

      reader.readAsDataURL(file);
    }
  }

  private scrollToAttachments() {
    // Clear any existing scroll timeout to prevent multiple simultaneous scrolls
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }

    // Only scroll if component is still active and visible
    if (!this.isComposeOpen && !this.isReply && !this.isForward) {
      return; // Don't scroll if not in compose mode
    }

    // Use timeout to ensure DOM is updated and debounce multiple calls
    this.scrollTimeout = setTimeout(() => {
      try {
        // Check if elements still exist
        if (!this.messageContainer?.nativeElement) {
          console.warn('Message container not found for scrolling');
          return;
        }

        const container = this.messageContainer.nativeElement;

        // Ensure container is visible and has scroll capability
        if (container.offsetHeight === 0 || container.scrollHeight <= container.clientHeight) {
          return; // No need to scroll if container is not visible or doesn't have scrollable content
        }

        if (this.attachmentsSection?.nativeElement) {
          // Calculate the scroll position within the container only
          const attachmentElement = this.attachmentsSection.nativeElement;
          const containerTop = container.offsetTop;
          const attachmentTop = attachmentElement.offsetTop;
          const scrollTop = Math.max(0, attachmentTop - containerTop - 20); // 20px offset for better visibility

          // Ensure scroll position is within bounds
          const maxScroll = Math.max(0, container.scrollHeight - container.clientHeight);
          const safeScrollTop = Math.min(scrollTop, maxScroll);

          // Only scroll if there's a meaningful distance to scroll
          if (Math.abs(container.scrollTop - safeScrollTop) > 50) {
            container.scrollTo({
              top: safeScrollTop,
              behavior: 'smooth'
            });
          }
        } else {
          // Fallback: gentle scroll towards bottom if attachments section not found
          const currentScroll = container.scrollTop;
          const maxScroll = Math.max(0, container.scrollHeight - container.clientHeight);
          const targetScroll = Math.max(currentScroll, maxScroll * 0.8); // Scroll to 80% of max scroll

          if (targetScroll > currentScroll) {
            container.scrollTo({
              top: targetScroll,
              behavior: 'smooth'
            });
          }
        }
      } catch (error) {
        console.error('Error during scroll to attachments:', error);
        // Fail silently to prevent crashes
      }
    }, 200); // Slightly increased timeout for better stability
  }

  async uploadFileParallel(file: File, index: number) {
    try {
      const presignedUrl = await this.uploadToS3(file);

      this.files[index].uploading = false;
      this.files[index].success = true;
      this.files[index].uploaded_url = presignedUrl;

      this.uploadedAttachments.push({
        fileName: file.name,
        mimeType: file.type,
        presignedUrl,
      });
    } catch (error) {
      this.files[index].uploading = false;
      this.files[index].error = true;
      // this.toast.error('Upload failed for ' + file.name);
    }
  }

  async uploadToS3(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      const folder = `crm/leads/attachments`;

      formData.append('file', file);
      formData.append('folders', folder);
      formData.append('bucket', 'global-upload-storage');

      this.uploadService.uploadDocuments(formData).subscribe({
        next: (response: any) => {
          resolve(response.url); // assuming response returns the uploaded file URL
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }

  formatSize(size: number): string {
    if (size < 1024) return `${size} B`;
    else if (size < 1048576) return `${(size / 1024).toFixed(2)} KB`;
    else return `${(size / 1048576).toFixed(2)} MB`;
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
    this.uploadedAttachments.splice(index, 1); // Remove from uploadedAttachments as well
  }


  handleUpdateDraft() {
    // Logic to update the draft email
    console.log('Draft updated.');



    const param = {
      subject: this.selectedRow.subject,
      contentType: 'HTML',
      bodyContent: this.parseDataToMakeEmptyDivToBr(this.editorData),
      recipientEmails: this.selectedRow.toRecipients.map((email: any) => email.emailAddress.address),
      fromEmail: this.localStorage.getEmail(),
      ccRecipients: this.selectedRow.ccRecipients.map((email: any) => email.emailAddress.address),
      // attachments: this.files,
      // client_id: this.localStorage.getClientId(),
      organization_id: this.localStorage.getOrganizationId(),
      messageId: this.replyId,
      draft_message_id: this.replyId,
      user_id: this.localStorage.getUserId()
    }

    this.clearData();

    console.log('Draft email param:', param);
    this.api.updateOutlookDraftEmail(param).subscribe({
      next: (res: any) => {
        console.log('Draft updated successfully:', res);

      },
      error: (err: any) => {
        console.error('Error updating draft:', err);
      }
    });
  }


  closeBottomSheet() {

    // make empty attachments and text
    this.files = [];
    this.uploadedAttachments = [];
    this.editorData = '';

    if (this.isReply || this.isReplyAll || this.isForward) {
      if (this.files.length > 0) {

        this.finalizeClose2();

      } else {
        // Directly update draft if there are no files
        this.handleUpdateDraft();
        this.finalizeClose();
      }
    } else {
      // Finalize close if none of the conditions are met
      this.finalizeClose();
    }
  }

  finalizeClose() {
    this.isReply = false;
    this.isReplyAll = false;
    this.isForward = false;
    this.closeCompose.emit();
  }

  finalizeClose2() {
    this.isReply = false;
    this.isReplyAll = false;
    this.isForward = false;
    this.closeCompose2.emit();
  }

  handleEmailAction(actionType: any) {
    if (this.uploadedAttachments.length > 0) {

      const attachmentPayload = {
        fromEmail: this.localStorage.getEmail(),
        draft_id: this.replyId,
        organization_id: this.localStorage.getOrganizationId(),
        attachments: this.uploadedAttachments,
        user_id: this.localStorage.getUserId()
      };

      console.log('Attachment payload:', attachmentPayload);
      this.api.addAttachmentInOutlookReply(attachmentPayload).subscribe({
        next: () => this.sendEmail(actionType),
        error: (e) => this.handleError(e, 'Error adding attachments')
      });
    } else {
      this.sendEmail(actionType);
    }
  }

  sendEmail(actionType: any) {
    let recipientEmails: any[] = [];
    if (actionType === 'forward') {
      recipientEmails = this.emails?.length > 0 ? this.emails : [this.emailInput];
    } else if (actionType === 'replyAll') {
      recipientEmails = [this.selectedRow.from.emailAddress.address, ...this.selectedRow.toRecipients.map((email: any) => email.emailAddress.address),
      ...this.selectedRow.ccRecipients.map((email: any) => email.emailAddress.address)
      ];
    } else if (actionType === 'reply') {
      recipientEmails = [this.selectedRow.from.emailAddress.address];
    }

    const emailPayload = {
      fromEmail: this.localStorage.getEmail(),
      draft_message_id: this.replyId,
      contentType: 'HTML',
      // client_id: this.localStorage.getClientId(),
      organization_id: this.localStorage.getOrganizationId(),
      bodyContent: this.parseDataToMakeEmptyDivToBr(this.editorData),
      recipientEmails: recipientEmails,
      user_id: this.localStorage.getUserId()
    };

    this.api.sendOutlookReply(emailPayload).subscribe({
      next: () => this.handleSuccess('Reply sent successfully'),
      error: (e) => this.handleError(e, 'Error sending email')
    });
  }

  handleSuccess(message: any) {
    // this.toast.success(message);

    if(message == 'Reply sent successfully') {
      // Handle specific success case
      this.messageService.add({ severity: 'success', summary: 'Success', detail: message });
    }

    setTimeout(() => {
      this.btnLoading = false;
      this.refresh.emit();
      this.closeCompose.emit();
      this.resetForm();
    }, 1000);
  }

  handleError(error: any, message: any) {
    console.error(error);
    // this.toast.error(message);
    this.btnLoading = false;
  }

  resetForm() {
    this.openBCC = false;
    this.openCC = false;
    this.subject = '';
    this.editorData = '';
    this.files = [];
    this.emails = [];
    this.ccEmails = [];
    this.emailInput = '';
    this.ccInput = '';
    this.isReply = false;
    this.isReplyAll = false;
    this.isForward = false;
    this.replyId = null;
    this.attachments = [];
    this.uploadedAttachments = [];
    this.closeBottomSheet();
    this.clearData();
  }

  handleReplyMessage() {
    this.handleEmailAction('reply');
  }

  handleReplyAllMessage() {
    this.handleEmailAction('replyAll');
  }

  handleForwardMessage() {
    this.handleEmailAction('forward');
  }


  sendMail() {
    // if (!this.to) {
    //   this.toast.error('Please enter a recipient email address');
    //   return;
    // }'

    if (this.isForward) {

      if (this.emails.length === 0 && !this.emailInput) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter a recipient email address' });
        return;
      }

      this.btnLoading = true;

      this.handleForwardMessage();

      return;
    }

    if (this.isReplyAll) {
      if (!this.editorData) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter a message' });
        return;
      }

      this.btnLoading = true;

      this.handleReplyAllMessage();

      return;
    }

    if (this.isReply) {
      if (!this.editorData) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter a message' });
        return;
      }

      this.btnLoading = true;

      this.handleReplyMessage();

      return;
    }

    if (this.emails.length === 0 && !this.emailInput) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter a recipient email address' });
      return;
    }

    if (!this.subject) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter a subject' });
      return;
    }

    if (!this.editorData) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter a message' });
      return;
    }

    console.log('Sending email...');
    this.btnLoading = true;

    // let attachments: any[] = [];

    // this.files.forEach((file) => {
    //   attachments.push({
    //     "@odata.type": "#microsoft.graph.fileAttachment",
    //     "name": file.file.name,
    //     "contentType": file.file.type,
    //     "contentBytes": file.preview?.split(',')[1]
    //   });
    // });

    const param: any = {
      subject: this.subject,
      contentType: 'HTML',
      bodyContent: this.parseDataToMakeEmptyDivToBr(this.editorData),
      recipientEmails: this.emails?.length > 0 ? this.emails : [this.emailInput],
      fromEmail: this.localStorage.getEmail(),
      ccRecipients: this.ccEmails?.length > 0 ? this.ccEmails : this.ccInput ? [this.ccInput] : [],
      // client_id: this.localStorage.getClientId(),
      draft_message_id: this.currentCreatedDraftId ? this.currentCreatedDraftId : this.selectedRow?.id,
      organization_id: this.localStorage.getOrganizationId(),
      user_id: this.localStorage.getUserId()
    }

    const attachmentPayload = {
      fromEmail: this.localStorage.getEmail(),
      draft_id: this.currentCreatedDraftId ? this.currentCreatedDraftId : this.selectedRow?.id,
      organization_id: this.localStorage.getOrganizationId(),
      attachments: this.uploadedAttachments,
      user_id: this.localStorage.getUserId()
    };

    const uploadAttachments$ = this.uploadedAttachments.length > 0
      ? this.api.addAttachmentInOutlookReply(attachmentPayload)
      : of(null); // Return an observable that emits null if no attachments

    uploadAttachments$
      .pipe(
        switchMap(() =>
          this.api.updateOutlookDraftEmail(param) // Update draft email after attachments upload
        ),
        switchMap(() =>
          this.api.sendOutlookDraftEmail(param) // Send email after update
        ),
        catchError((err: any) => {
          console.error('Error occurred:', err);
          // this.toast.error('An error occurred while processing your request');
          this.btnLoading = false;
          // Return an empty observable or handle fallback here
          return of(null);
        })
      )
      .subscribe((res: any) => {
        if (res) {
          // this.toast.success('Email sent successfully');
          setTimeout(() => {
            this.btnLoading = false;
            this.refresh.emit();
            this.makeIsDraftFalse.emit();
            this.closeCompose.emit();
            this.openBCC = false;
            this.openCC = false;
            this.subject = '';
            this.editorData = '';
            this.files = [];
            this.emails = [];
            this.ccEmails = [];
            this.emailInput = '';
            this.ccInput = '';
            this.attachments = [];
            this.uploadedAttachments = [];
          }, 1000);
        }
      });




  }


  parseDataToMakeEmptyDivToBr(data: string): string {
    // Replace empty <div> with <br>
    return data.replace(/<div><\/div>/g, '<br>');
  }


  addEmail(): void {
    if (this.emailInput && this.isValidEmail(this.emailInput)) {
      this.emails.push(this.emailInput);
      this.emailInput = '';  // Clear the input field
    } else {
      // alert('Please enter a valid email address.');
      // this.toast.error('Please enter a valid email address.');
    }
  }

  // Remove email from the chip list
  removeEmail(email: string): void {
    const index = this.emails.indexOf(email);
    if (index >= 0) {
      this.emails.splice(index, 1);
    }
  }

  addCc(): void {
    if (this.ccInput && this.isValidEmail(this.ccInput)) {
      this.ccEmails.push(this.ccInput);
      this.ccInput = '';  // Clear the input field
    } else {
      // alert('Please enter a valid CC email address.');
      // this.toast.error('Please enter a valid CC email address.');
    }
  }

  // Remove CC email from the chip list
  removeCc(ccEmail: string): void {
    const index = this.ccEmails.indexOf(ccEmail);
    if (index >= 0) {
      this.ccEmails.splice(index, 1);
    }
  }


  // Validate email format using a simple regex (optional)
  isValidEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  clearData() {
    this.subject = '';
    this.editorData = '';
    this.files = [];
    this.emails = [];
    this.ccEmails = [];
    this.emailInput = '';
    this.ccInput = '';
    this.attachments = [];
  }

  fillData(data: any, content: string) {
    this.draft_message_id = data.id;
    this.subject = data.subject;
    this.editorData = content;
    this.emails = data?.toRecipients?.map((email: any) => email.emailAddress.address);
    this.openCC = data.ccRecipients?.length > 0;
    this.ccEmails = data.ccRecipients?.map((email: any) => email.emailAddress.address);
    // this.files = data.attachments;
  }

  handleReply() {
    this.isReply = true;
    this.subject = `Re: ${this.selectedRow.subject}`;
    this.emails = [this.selectedRow.from.emailAddress.address];
    this.openCC = false;
    this.ccEmails = [];

    setTimeout(() => {
      this.scrollToTop();
    }, 100);

    const payload = {
      fromEmail: this.localStorage.getEmail(),
      message_id: this.selectedRow.id,
      organization_id: this.localStorage.getOrganizationId(),
      user_id: this.localStorage.getUserId()
    }

    this.api.createOutlookReply(payload).subscribe({
      next: (res) => {
        this.replyId = res?.id;

        console.log('Reply ID:', this.replyId);
      },
      error: (e) => {
        console.error(e);
      }
    });

  }

  handleReplyAll() {
    this.isReply = true;
    this.isReplyAll = true;
    this.subject = `Re: ${this.selectedRow.subject}`;
    this.emails = [this.selectedRow.from.emailAddress.address, ...this.selectedRow.toRecipients.map((email: any) => email.emailAddress.address)];

    // remove duplicates
    this.emails = this.emails.filter((email, index, self) => self.indexOf(email) === index);

    this.ccEmails = this.selectedRow.ccRecipients.map((email: any) => email.emailAddress.address);
    this.openCC = this.ccEmails.length > 0;

    setTimeout(() => {
      this.scrollToTop();
    }, 100);


    const payload = {
      fromEmail: this.localStorage.getEmail(),
      message_id: this.selectedRow.id,
      organization_id: this.localStorage.getOrganizationId(),
      user_id: this.localStorage.getUserId()
    }

    this.api.createOutlookReply(payload).subscribe({
      next: (res) => {
        this.replyId = res?.id;

        console.log('Reply ID:', this.replyId);
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  handleForward() {
    this.isForward = true;
    this.subject = `Fwd: ${this.selectedRow.subject}`;
    this.emails = [];
    this.openCC = false;
    this.ccEmails = [];

    setTimeout(() => {
      this.scrollToTop();
    }, 100);

    const payload = {
      fromEmail: this.localStorage.getEmail(),
      message_id: this.selectedRow.id,
      organization_id: this.localStorage.getOrganizationId(),
      // client_id: this.localStorage.getClientId()
      user_id: this.localStorage.getUserId()
    }

    this.api.forwardOutlookEmail(payload).subscribe({
      next: (res) => {
        this.replyId = res?.id;
        console.log('Reply ID:', this.replyId);
      },
      error: (e) => {
        console.error(e);
      }
    });


  }

  isImage(file: File): boolean {
    return file?.type?.startsWith('image/');
  }

  isVideo(file: File): boolean {
    return file?.type?.startsWith('video/');
  }

  isPDF(file: File): boolean {
    return file?.type === 'application/pdf';
  }

  scrollToTop(): void {
    console.log("scrolling to top");
    try {
      this.messageContainer.nativeElement.scrollTo({
        top: 0, // Scroll to the top
        behavior: 'smooth' // Enables smooth scrolling
      });
    } catch (err) {
      console.error('Scroll to top failed:', err);
    }
  }

  getImageUrl(contentType: string, contentBytes: string): any {
    if (!contentBytes) return '';
    const base64Url = `data:${contentType};base64,${contentBytes}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(base64Url);
  }


  openInNewTab(url: string): void {
    // const encodedUrl = encodeURIComponent(url); // Encode if necessary
    // console.log('Opening URL:', encodedUrl);
    // window.open(encodedUrl, '_blank');
  }

  // openAttachment(
  //   content: any, attachment: any
  // ) {

  //   this.selectedAttachment = {
  //     name: attachment.name,
  //     contentType: attachment.contentType,
  //     url: this.getImageUrl(attachment.contentType, attachment.contentBytes)
  //   };

  //   // this.modalService.open(content, {
  //   //   size: 'lg', scrollable: true,
  //   //   centered: true,
  //   //   backdrop: 'static',
  //   // })
  // }

  downloadFile(attachment: { name: string; contentType: string; contentBytes: string }): void {
    const blob = this.base64ToBlob(attachment.contentBytes, attachment.contentType);
    const url = window.URL.createObjectURL(blob);

    // Create an anchor element and trigger download
    const a = document.createElement('a');
    a.href = url;
    a.download = attachment.name; // Set the file name
    a.click();

    // Clean up the URL object
    window.URL.revokeObjectURL(url);
  }

  /**
   * Convert Base64 string to Blob
   */
  private base64ToBlob(base64: string, contentType: string): Blob {
    const byteCharacters = atob(base64); // Decode Base64
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  // onReady(eventData: any) {
  //   eventData.plugins.get('FileRepository').createUploadAdapter = function (loader: any) {
  //     console.log(btoa(loader.file));
  //     return new UploadAdapter(loader);
  //   };

  //   eventData.plugins.get('ImageResize').enable({
  //     handleSize: 50,
  //     handleStyles: {
  //       display: 'block',
  //       'background-color': 'black',
  //       'border-radius': '50%',
  //       'border': '1px solid white',
  //       'box-shadow': '0 0 0 2px black',
  //       'box-sizing': 'content-box',
  //       'height': '16px',
  //       'width': '16px'
  //     }
  //   });

  //   // editorObj.keystrokes.set('Shift+Enter', 'enter');
  //   // editor.value = editorObj;

  //   eventData.editing.view.document.on(
  //     'enter',
  //     (evt: any, data: any) => {
  //       eventData.execute('shiftEnter'); // insert <br> instead of <p>
  //       data.preventDefault();        // cancel default enter
  //       evt.stop();                   // stop further handling
  //     },
  //     { priority: 'high' }
  //   );

  // }



  removeAttchment(index: number,
    attachmentId: any
  ) {

    this.attachments.splice(index, 1);

    const payload = {
      fromEmail: this.localStorage.getEmail(),
      draft_message_id: this.draft_message_id,
      attachment_id: attachmentId,
      // client_id: this.localStorage.getClientId()
      user_id: this.localStorage.getUserId()
    }

    this.api.deleteAttachmentInOutlook(payload).subscribe({
      next: (res) => {
        console.log('Attachment deleted:', res);
      },
      error: (e) => {
        console.error('Error deleting attachment:', e);
      }
    });
  }


}


export class UploadAdapter {
  private loader: any;

  constructor(loader: any) {
    this.loader = loader;
  }

  public async upload(): Promise<any> {
    return this.loader.file
      .then((file: File) => this.readThis(file))
      .then((dataUrl: any) => {
        return { default: dataUrl };
      });
  }

  readThis(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }
}